module.exports = __webpack_public_path__ + "img/logo_avis.cab4cdd0.png";